import React from "react";
import Input from "../Input";
import {Tooltip} from "antd";
import "./index.less";
export default ({ value, onChange, opts={}}) => {
    const { disabled = false } = opts;
    const f = (() => {
        if (!value) return "K";
        let m = /^[A-Za-z]+/.exec(value);
        return m ? m[0].toUpperCase() : "K"; 
    })();
    const m = (() => {
        if (!value) return "";
        let m = /^[A-Za-z]+(\d+)/.exec(value);
        return m ? m[1] : ""; 
    })() 
    const e = (() => {
        if (!value) return "";
        let m = /\+(\d+)(\.\d*)?$/.exec(value);
        let m1 = m ? m[1].substr(0,3) : '';
        let m2 = m && m[2] ? m[2].substr(1,3) : '';
        return m ? m[2] ? m1 + '.' + m2 : m1 : ""; 
    })() 
   
    return (
        <>
        {value && disabled ? <Tooltip placement="topLeft" title={value}>
            <div className={"TUI-Mileage"}>
                <Input value={f} opts={opts}/>
                <Input value={m} opts={opts}/>
                <Input value={e} opts={opts}/>
            </div>
        </Tooltip> : 
        <div className={"TUI-Mileage"}>
           <Input value={f} onChange={v => {
               onChange((v || "").replace(/[^A-Za-z]/g, "") + m + (e ? "+" + e : ""))
           }} opts={opts}/>
           <Input value={m} onChange={v => {
               onChange(f + (v || "").replace(/[^0-9]/g, "") + (e ? "+" + e : ""))
           }} opts={opts}/>
           <Input value={e} onChange={v => {
               // let  t = (v || "").replace(/[^0-9]/g, "").substr(0,3);
               let t0 = /^(\d+)(\.\d*)?$/.exec(v||'');
               let t1 = t0 ? t0[1].substr(0,3) : '';
               let t2 = t0 && t0[2] ? t0[2].substr(0,4) : '';
               onChange(f + m + (t0 ? "+" + t1 + t2 : ""))
           }} opts={opts}/>
       </div>}
        </>
    )
}